import { Button } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, Input, Select, message } from 'antd';
import { getListTeacherDropdown } from 'requests/teacher';
import { addClass, addTeacherClass } from 'requests/class';
import _ from 'lodash';

const AddClass = () => {
    const [loading, setLoading] = useState(false);
    const [teachers, setTeachers] = useState([]);
    const [teacherTake, setTeacherTake] = useState(20);
    const [teacherTotal, setTeacherTotal] = useState(21);
    const [teacherSearch, setTeacherSearch] = useState('');
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        return () => {
            sessionStorage.setItem('is_form_changed', 0);
        };
    }, []);

    const onAddClass = async () => {
        try {
            const values = await form.validateFields();
            for (const key in values) {
                if (typeof values[key] === 'string') values[key] = values[key].trim();
            }
            form.setFieldsValue(values);

            const classData = { className: values.className };
            const assignData = { memberIds: [values.teacher] };
            const classResponse = await addClass(classData);
            if (values.teacher) await addTeacherClass(classResponse.id, assignData);
            message.success(t('success'));
            navigate('/classes');
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        }
    };

    useEffect(() => {
        getData();
    }, [teacherTake, teacherSearch]);

    const getData = async () => {
        try {
            setLoading(true);

            const data = await getListTeacherDropdown({ role: 2, take: teacherTake, search: teacherSearch });
            const teacherOptions = data.records.map((record) => {
                return { label: record.name, value: record.id };
            });

            setTeacherTotal(data.total);
            setTeachers(teacherOptions);
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = _.debounce(setTeacherSearch, 400);

    const handleScroll = (e) => {
        const target = e.target;
        if (
            !loading &&
            teacherTake < teacherTotal &&
            target.scrollTop + target.offsetHeight >= target.scrollHeight - 10
        ) {
            setTeacherTake(teacherTake + 10);
        }
    };

    return (
        <div className="add-edit-page">
            <div className="add-edit-form">
                <h1 className="mt-32 mb-40">{t('add_class')}</h1>
                <div className="add-input">
                    <Form
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                        form={form}
                        initialValues={{ status: 1 }}
                        onValuesChange={() => sessionStorage.setItem('is_form_changed', 1)}
                    >
                        <Form.Item
                            name="className"
                            label={t('class_name')}
                            rules={[{ required: true, pattern: /\S+/, message: t('required_field') }]}
                        >
                            <Input placeholder={t('input_name_add')} />
                        </Form.Item>

                        <Form.Item label={t('teacher_in_charge')} name="teacher">
                            <Select
                                showSearch
                                filterOption={false}
                                onSearch={handleSearch}
                                onPopupScroll={handleScroll}
                                style={{ width: '100%' }}
                                placeholder={t('select_teacher')}
                                optionLabelProp="label"
                                options={teachers}
                                onDropdownVisibleChange={() => setTeacherSearch('')}
                            ></Select>
                        </Form.Item>
                    </Form>
                </div>
            </div>

            <div className="add-edit-btn">
                <Button onClick={() => navigate(-1)} className="ant-btn cancel-btn">
                    {t('cancel')}
                </Button>
                <Button className="ant-btn save-btn" onClick={onAddClass}>
                    {t('save')}
                </Button>
            </div>
        </div>
    );
};

export default AddClass;
